import { render, staticRenderFns } from "./EsAligner.vue?vue&type=template&id=c9540e60"
import script from "./EsAligner.vue?vue&type=script&lang=ts"
export * from "./EsAligner.vue?vue&type=script&lang=ts"
import style0 from "./EsAligner.vue?vue&type=style&index=0&id=c9540e60&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports